module.exports = {
  brandKeyNameMap: {
    hb: 'Henrybuilt',
    st: 'Space Theory',
    po: 'Primary Objects'
  }
};
